enum ReactivationMessages {
  SUBSCRIPTION_ERROR = 'Reactivate Error: ',
  SUBMIT_CTA_NAME = 'REACTIVATE',
}

export { ReactivationMessages };
